import React, { useState } from 'react';
import uuid from 'uuid';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { isStaleChunkError, reloadOnStaleAssets } from 'src/utils/staleAssetReload';

export default function ErrorBoundary({ children, FallbackComponent, ...props }) {
	const [errorCode, setErrorCode] = useState(uuid.v4());

	const onError = (error, info) => {
		const code = uuid.v4();
		setErrorCode(code);

		if (isStaleChunkError(error)) {
			reloadOnStaleAssets();
		}

		if (props.onError) {
			props.onError(error, info, code);
		}
	};

	const onReset = () => {
		if (props.onReset) {
			props.onReset();
		}
	};

	if (!FallbackComponent) {
		return null;
	}

	return (
		<ReactErrorBoundary
			fallbackRender={(fallbackProps) => (
				<FallbackComponent
					{...fallbackProps}
					errorCode={errorCode}
				/>
			)}
			onError={onError}
			onReset={onReset}
		>
			{children}
		</ReactErrorBoundary>
	);
}
